interface WorldCupMascotProps {
    staticBaseUrl: string
    /** Positioning/visibility classes for the mascot container (passed by the header). */
    className?: string
}

/**
 * World Cup search-widget mascot: soccer-Chiku playing with the ball.
 *
 * The source asset (`soccer-chiku-fifa-header.png`) is a single flat bitmap with the
 * ball baked in. We draw it twice and clip each copy (classes in globals.css) so the
 * ball can move independently of Chiku without shipping any new CDN asset:
 *   - base layer — masks the ball's circle out, leaving Chiku (incl. the foot/toe)
 *   - ball layer — shows only the ball's circle and runs the juggle keyframes
 *
 * At rest the two layers reconstruct the original composite exactly. The animation
 * plays once on load and is disabled under `prefers-reduced-motion`. Pure CSS — no
 * client JS required.
 */
export function WorldCupMascot({ staticBaseUrl, className }: WorldCupMascotProps) {
    const src = `${staticBaseUrl}c2c/soccer-chiku-fifa-header.png`

    return (
        <div className={className}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                alt=""
                aria-hidden="true"
                className="wc-mascot-base absolute inset-0 h-full w-full object-contain"
                src={src}
            />
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                alt=""
                aria-hidden="true"
                className="wc-mascot-ball wc-mascot-ball-animate absolute inset-0 h-full w-full object-contain"
                src={src}
            />
        </div>
    )
}
